import AutoVerificationResults from "@/components/probaworkflows_base_components/AutoVerificationResults/AutoVerificationResults.vue";
import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import AutoVerificationServices from '@/components/probaworkflows_base_components/AutoVerificationServices/AutoVerificationServices.vue';
import {
  get_user_role, GET_VERIFICATION_LOGS, get_headers, GET_PROJECTS_ASSIGNED_TO_SERVICE
} from '@/utils/constants/constants.js';
import axios from 'axios';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import $ from 'jquery';
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from '@/utils/mixins/formatting_mixins';

export default {
  name: "VerificationResultsPage",
  mixins: [alert_mixin, formatting_mixins],

  components: {
    AutoVerificationResults,
    AutoVerificationServices,
    NavigationBackButton,
  },
  data: () => ({
    application_id: null,
    entity_profile_id: null,
    user_role: null,
    verification_logs: [],
    verification_services: [],
    headers: get_headers(),
    project_id: sessionStorage.getItem('project_id'),
  }),

   async created() {
    this.user_role = get_user_role();
  },

  computed: {
    resolved_entity_profile_id() {
      if (this.entity_profile_id) return this.entity_profile_id;
      const route_entity_id = this.$route?.params?.entity_profile_id;
      if (route_entity_id) return route_entity_id;
      const entity_profile_id = sessionStorage.getItem('entity_profile_id');
      if (entity_profile_id) return entity_profile_id;
      return null;
    },
    
    resolved_lead_id() {
      const entity_profile_id = this.resolved_entity_profile_id;
      if (entity_profile_id) return null;
      const route_lead_id = this.$route?.query?.lead_id;
      if (route_lead_id) return route_lead_id;
      return sessionStorage.getItem('lead_id');
    },
  },
  mounted() {
    this.load_ids_from_session();    // Clear lead context when viewing applicant verification
    if (this.entity_profile_id) {
      sessionStorage.removeItem("lead_id");
      sessionStorage.removeItem("lead_form_id");
    }
    this.fetch_verification_services();
  },
  methods: {

    open_verification_modal() {
      this.$refs.verification_modal.open_modal();
    },
    load_ids_from_session() {
      // Get IDs from sessionStorage (adjust keys based on your app)
      this.application_id = sessionStorage.getItem("application_id") || 
                           sessionStorage.getItem("current_application_id");
      
      this.entity_profile_id = sessionStorage.getItem("entity_profile_id") || 
                              sessionStorage.getItem("current_entity_profile_id");

      // If not in session, try to get from route params
      if (!this.application_id && this.$route.params.application_id) {
        this.application_id = this.$route.params.application_id;
      }
      
      if (!this.entity_profile_id && this.$route.params.entity_profile_id) {
        this.entity_profile_id = this.$route.params.entity_profile_id;
      }
    },

    initialize_data_table() {
      this.$nextTick(() => {
        const table = $('#verification_logs_table');
        if ($.fn.DataTable.isDataTable(table)) {
          table.DataTable().destroy();
        }

        table.DataTable({
          responsive: true,
          emptyTable: "No data available in table",
          language: {
            info: "",
            lengthMenu: "_MENU_&nbsp;&nbsp;Entries per page"
          }
        });
      });
    },

    open_verification_logs() {
      this.get_verification_logs();
    },

    get_service_name(service_id) {
      const service = this.verification_services.find(s => s.id === service_id);
      return service ? service.name : `Service ${service_id}`;
    },

    get_display_message(message) {
      const match = message.match(/\[(.*?)\]/);
      if (match) {
      const group = Reflect.get(match, '1');
      const fields = group.split(',').map(f => f.trim().replace(/['"]/g, ''));
        return `Missing required AML fields: ${fields.join(', ')}`;
      }
      return message;
    },

    get_verification_logs() {
      // Update to handle both entity_profile_id and lead_id
      const params = {};
      
      if (this.resolved_entity_profile_id) {
        params.entity_profile_id = this.resolved_entity_profile_id;
      } else if (this.resolved_lead_id) {
        params.lead_id = this.resolved_lead_id;
      } else {
        return;
      }
      
      axios.get(GET_VERIFICATION_LOGS, {
        headers: this.headers,
        params: params
      })
      .then(response => {
        const parsed_response = response.data;
        if (parsed_response.status === "success") {
          this.verification_logs = parsed_response.logs || [];
          this.$nextTick(() => this.initialize_data_table());
        } else {
          this.show_error(parsed_response.message || "No logs found");
        }
      })
      .catch(error => {
        this.show_error("Error fetching verification logs: " + error);
      });
    },

    async fetch_verification_services() {
      this.loading_services = true;
      try {
        const response = await axios.get(GET_PROJECTS_ASSIGNED_TO_SERVICE, {
          headers: this.headers,
          params: { project_id: this.project_id },
        });
        const parsed = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;
        if (parsed.status === 'success' && parsed.data) {
          this.verification_services = parsed.data.map(service => ({
            id: service.id,
            name: service.name,
            description: service.description,
            is_active: service.is_active
          }));
        } else this.show_error(parsed.message || 'Failed to fetch services');
      } catch {
        this.show_error('Failed to load verification services.');
      } finally {
        this.loading_services = false;
      }
    },
  }
};